import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            retryOnMount: false,
        },
    },
});

// Enable Tanstack Query Devtools for non-production environments
if (!window.PRODUCTION) {
    window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}
